export default __webpack_public_path__ + "static/media/facebook.be2603b4.svg";